// Demo Client Config
import template from "./_template";

const mb_config = {
  name: "mb",
  disabled_features: {
    ...template.disabled_features,
    qa_header: true,
  },
  enabled_features: {
    ...template.enabled_features,
    // Optional features
    dataset_dip: true,
    dataset_import: true,
    inbound_message: true,
    emergency_campaign_priority: true,
    campaign_templates: true,
    wav_upload: true,
    url_shortner: true,
    optout_upload: true,
  },
  sms: {
    short_codes: [
      { label: "22986 (REST)", value: "22986" }, // REST
      { label: "700800 (XML)", value: "700800" }, // XML
    ],
  },
  voice: {
    premium_options: ["all"], // "all" || "premium" | "french" | "german" | "spanish"
    caller_id_options: [
      { label: "Select a phone number", isDisabled: true },
      { label: "(234) 567-8901", value: "2345678901" },
    ],
  },
};

export default mb_config;
